<ng-template #ficheConsultantPortalContent>
  @if (codeConsultant()) {
    @let doc = viewerDocument();

    <div
      class="fiche-consultant-container"
      [class.hidden]="!!doc"
      [class.expend]="isExpendSideNav()">
      <lib-fiche-consultant
        [codeConsultant]="codeConsultant()!"
        [refreshDocs]="refreshDocs()"
        [enableNavigation]="enableNavigation()"
        [disableResiliation]="disableResiliation()"
        [viewerDocument]="viewerDocument()"
        [isExpendSideNav]="isExpendSideNav()"
        (close)="closeSlidePanel()"
        (expendSideNav)="expendSideNav()"
        (documentOpen)="openDocument($event)"
        (onRefreshDocs)="onRefreshDocs()"
        (requestResiliation)="requestResiliation.emit()"></lib-fiche-consultant>
    </div>

    @if (doc) {
      <oui-document-viewer
        class="slide-panel-viewer"
        [documentUrl]="doc.url!"
        [showControls]="true">
        <div oui-document-controls>
          <div class="document-name-container">
            <div class="document-name">
              <div class="headline-6">{{ doc.documentName }}</div>
              <div class="file-name body-1">{{ doc.fileName }}</div>
            </div>

            <oui-button type="icon" color="secondary" (click)="closeDocument()">
              <oui-icon>close</oui-icon>
            </oui-button>
          </div>
          @if (isUploadDoc()) {
            <div class="document-informations">
              <oui-autocomplete
                label="Type de document"
                [control]="typeControl"
                [options]="typeDocumentOptions"
                style="padding-bottom: 0.5rem"></oui-autocomplete>

              <oui-button-toggle
                [style]="isDocPrivateOnly() ? 'pointer-events: none !important' : null"
                label="Visibilité du document"
                [(value)]="valueToggle"
                [options]="toggleOptions"></oui-button-toggle>

              <oui-autocomplete
                label="Section du document"
                [control]="sectionControl"
                [options]="sectionOption"
                style="padding-bottom: 0.5rem"></oui-autocomplete>

              @if (isLoading()) {
                <div class="loading-container">
                  <oui-loading></oui-loading>
                </div>
              } @else {
                @let cmp = formComponent();
                @if (cmp) {
                  <ng-container
                    [ngComponentOutlet]="cmp"
                    [ngComponentOutletInputs]="{ codeConsultant: codeConsultant() }">
                  </ng-container>
                }
              }

              <div document-viewer-footer class="footer actions">
                <oui-button
                  class="actions__btn-send"
                  [disabled]="!isValid() || isLoading()"
                  (click)="saveDocument()"
                  >Transmettre le document</oui-button
                >
              </div>
            </div>
          }
        </div>
      </oui-document-viewer>
    }
  }
</ng-template>
